import { BaseConfig } from './baseConfig';

const customConfig = {
  "apiRegistrationToken": "$2y$10$u1zVgUEarYkXfAVaILbg/O1xy.7oJJg5MnkMjpta3youaMO2LMvGq",
  "apiHostGateway": "https://api.sandbox.finalcad.cloud",
  "apiHostGatewayGlobal": "https://api.global.sandbox.finalcad.cloud",
  "clarityProjectId": "sb8wrxq21e",
  "grpcGateway": "https://realtime-service-pusher.sandbox.finalcad.cloud",
  "pdfTronLicenseKey": "demo:1777387556628:633f9b990300000000fa58eb0a06a93a0abf9e23d6de4f59fbd33d57fb",
  "firebaseConfig": {
    "apiKey": "AIzaSyDQQs8qA71W7cD6jTkkr8xuMoBjwacpm6U",
    "authDomain": "finalcad-one-beta.firebaseapp.com",
    "databaseURL": "https://finalcad-one-beta.firebaseio.com",
    "projectId": "finalcad-one-beta",
    "storageBucket": "finalcad-one-beta.appspot.com",
    "messagingSenderId": "896568218983",
    "appId": "1:896568218983:web:5ce2dd020ad16392e18bc2",
    "measurementId": "G-CN7FTY3VFW"
  },
  "stripeCheckoutKey": "pk_test_51ILQ3mLfL2ThMUp8pTzJVg40sM7RsD7uiDDNlc0N5KVrP9VGD6PH4IYUFSpUue6OMlH6sS1TvXgtkOQVXVZJs8fw00zmqqylhD",
  "sentry": {
    "environment": "sandbox",
    "dsn": "https://b2eacd9ee816459db8255b0242269e03@o1003935.ingest.sentry.io/5964925"
  },
  "customerIo": {
    "siteId": "5aa567bbd35b145b3166",
    "apiKey": "4a0c7d3ec55e1047d6db"
  },
  "gleap": {
    "appToken": "JLKq5vEGs1w9TKZPRl15SYQGJpYtTi1N"
  },
  "googleMapsApiKey": "AIzaSyAEmhLO21A_KSfPNbh6QMQMpfco7TOkluQ",
  "auth0": {
    "domain": "finalcad-one-preview.eu.auth0.com",
    "clientId": "MHRK4pVMLv8ylDqTagN2FBWMKcwkYr9Y",
    "audience": "https://auth0.api.preview.finalcad.com",
    "tokenUrl": "https://finalcad-one-preview.eu.auth0.com/oauth/token",
    "passwordRealmGrantType": "http://auth0.com/oauth/grant-type/password-realm",
    "refreshTokenGrantType": "refresh_token",
    "grantType": "http://auth0.com/oauth/grant-type/password-realm",
    "realm": "Username-Password-Authentication",
    "scope": "openid profile email offline_access"
  },
  "kolimmo": {
    "url": "https://app.staging.kolimmo.com/pro/sites"
  }
};

const Config = {
  ...BaseConfig,
  ...customConfig,
};

export default Config;

